import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function useGiftItem(giftItemId: string) {
    const { data, status } = useQuery(queries.giftItem.detail(giftItemId));
    const { pop } = useFlow();
    const toast = useToast();
    const { t } = useTranslation('gift');
    useEffect(() => {
        if (status === 'error') {
            toast.error(t('giftItem.loadError'));
            pop();
        }
    }, [pop, toast, status, t]);
    return data;
}

export default useGiftItem;
